// eslint-disable-next-line @typescript-eslint/no-explicit-any
const global = window;
export default global;
//# sourceMappingURL=global.js.map